import { create } from "zustand";

/**
 * Режим разработчика — как в Discord: в меню появляется «Копировать ID».
 * Обычному человеку номера ни к чему, поэтому по умолчанию выключен; выбор
 * хранится на устройстве.
 */
const KEY = "airel.developer";

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export const useDeveloper = create<{ on: boolean }>()(() => ({ on: read() }));

export function setDeveloper(on: boolean) {
  useDeveloper.setState({ on });
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // Не записалось — режим доживёт до конца сеанса в памяти.
  }
}
